class AsaTabs extends HTMLElement {
  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[data-asa-tab-trigger]'));
    this.panels = Array.from(this.querySelectorAll('[data-asa-tab-panel]'));

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.select(trigger.dataset.tab));
      trigger.addEventListener('keydown', (event) => this.onKeydown(event, trigger));
    });
  }

  select(tabId) {
    this.triggers.forEach((trigger) => {
      const active = trigger.dataset.tab === tabId;
      trigger.classList.toggle('asa-tabs__tab--active', active);
      trigger.setAttribute('aria-selected', String(active));
      trigger.tabIndex = active ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.asaTabPanel !== tabId;
    });
  }

  onKeydown(event, trigger) {
    const index = this.triggers.indexOf(trigger);
    let nextIndex = null;

    if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.triggers.length;
    if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.triggers.length) % this.triggers.length;

    if (nextIndex !== null) {
      event.preventDefault();
      const nextTrigger = this.triggers[nextIndex];
      nextTrigger.focus();
      this.select(nextTrigger.dataset.tab);
    }
  }
}

customElements.define('asa-tabs', AsaTabs);
